/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BranchDto } from './BranchDto';
import {
    BranchDtoFromJSON,
    BranchDtoFromJSONTyped,
    BranchDtoToJSON,
    BranchDtoToJSONTyped,
} from './BranchDto';

/**
 * 
 * @export
 * @interface PracticeUserDto
 */
export interface PracticeUserDto {
    /**
     * User ID
     * @type {string}
     * @memberof PracticeUserDto
     */
    id: string;
    /**
     * Account ID
     * @type {string}
     * @memberof PracticeUserDto
     */
    accountId: string;
    /**
     * User email
     * @type {string}
     * @memberof PracticeUserDto
     */
    email: string;
    /**
     * User full name
     * @type {string}
     * @memberof PracticeUserDto
     */
    name: string;
    /**
     * Phone number
     * @type {string}
     * @memberof PracticeUserDto
     */
    phoneNumber: string;
    /**
     * Phone dial code (e.g. +1)
     * @type {string}
     * @memberof PracticeUserDto
     */
    phoneNumberCountryCode?: string;
    /**
     * Phone country ISO alpha-2 code (e.g. US)
     * @type {string}
     * @memberof PracticeUserDto
     */
    phoneNumberCountryIso2?: string;
    /**
     * User role
     * @type {string}
     * @memberof PracticeUserDto
     */
    role: string;
    /**
     * NPI number
     * @type {string}
     * @memberof PracticeUserDto
     */
    npi?: string;
    /**
     * List of branches
     * @type {Array<BranchDto>}
     * @memberof PracticeUserDto
     */
    branches: Array<BranchDto>;
    /**
     * List of specialties
     * @type {Array<string>}
     * @memberof PracticeUserDto
     */
    specialties: Array<string>;
    /**
     * User status
     * @type {string}
     * @memberof PracticeUserDto
     */
    status: PracticeUserDtoStatusEnum;
    /**
     * Date when the role was created
     * @type {string}
     * @memberof PracticeUserDto
     */
    addedDate: string;
}


/**
 * @export
 */
export const PracticeUserDtoStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;
export type PracticeUserDtoStatusEnum = typeof PracticeUserDtoStatusEnum[keyof typeof PracticeUserDtoStatusEnum];


/**
 * Check if a given object implements the PracticeUserDto interface.
 */
export function instanceOfPracticeUserDto(value: object): value is PracticeUserDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('branches' in value) || value['branches'] === undefined) return false;
    if (!('specialties' in value) || value['specialties'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('addedDate' in value) || value['addedDate'] === undefined) return false;
    return true;
}

export function PracticeUserDtoFromJSON(json: any): PracticeUserDto {
    return PracticeUserDtoFromJSONTyped(json, false);
}

export function PracticeUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PracticeUserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'accountId': json['accountId'],
        'email': json['email'],
        'name': json['name'],
        'phoneNumber': json['phoneNumber'],
        'phoneNumberCountryCode': json['phoneNumberCountryCode'] == null ? undefined : json['phoneNumberCountryCode'],
        'phoneNumberCountryIso2': json['phoneNumberCountryIso2'] == null ? undefined : json['phoneNumberCountryIso2'],
        'role': json['role'],
        'npi': json['npi'] == null ? undefined : json['npi'],
        'branches': ((json['branches'] as Array<any>).map(BranchDtoFromJSON)),
        'specialties': json['specialties'],
        'status': json['status'],
        'addedDate': json['addedDate'],
    };
}

export function PracticeUserDtoToJSON(json: any): PracticeUserDto {
    return PracticeUserDtoToJSONTyped(json, false);
}

export function PracticeUserDtoToJSONTyped(value?: PracticeUserDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'accountId': value['accountId'],
        'email': value['email'],
        'name': value['name'],
        'phoneNumber': value['phoneNumber'],
        'phoneNumberCountryCode': value['phoneNumberCountryCode'],
        'phoneNumberCountryIso2': value['phoneNumberCountryIso2'],
        'role': value['role'],
        'npi': value['npi'],
        'branches': ((value['branches'] as Array<any>).map(BranchDtoToJSON)),
        'specialties': value['specialties'],
        'status': value['status'],
        'addedDate': value['addedDate'],
    };
}

